import { twClassMerge } from '@healthhub/react-ui';
import { Steps } from 'antd';
import type { ReactNode } from 'react';

import './styles.css';

interface Props {
  children?: ReactNode;
  className?: string;
  current?: number;
  direction?: 'horizontal' | 'vertical';
  labelPlacement?: 'horizontal' | 'vertical';
  onChange?: (stepValue: number) => void;
  responsive?: boolean;
}

const StyledSteps = ({ children, className, current, direction, labelPlacement, onChange, responsive }: Props) => (
  <Steps
    className={twClassMerge(className, 'steps')}
    current={current}
    direction={direction}
    labelPlacement={labelPlacement}
    onChange={onChange}
    responsive={responsive}
  >
    {children}
  </Steps>
);

export default StyledSteps;
